import React, { useEffect, useState } from 'react'
import { createEntityAdapter } from '@reduxjs/toolkit'
import { renderDateTime } from '../../../utils/dateFormatter'
import ICSDataGrid from '../../../components/ICSDataGrid/ICSDataGrid'
import { useDispatch, useSelector } from 'react-redux'
import renderFiles from './ResultsCellRender/RenderFiles'
import { DefaultState } from '../../../types'
import { ResultEntity } from '../../../types/results'
import ICSErrorCard from '../../../components/ICSErrorCard/ICSErrorCard'
import ResultFilesModal from './ResultFilesModal/ResultFilesModal'
import { ICSActionIcon } from '../../../components'
import { removeResult, getAllResults } from '../../../redux/slices'
import { AppDispatch } from '../../../services/lib'
const ResultsDisplay = () => {
  const initialState: ResultEntity = {
    id: '',
    analyzer: { id: '', name: '' },
    status: '',
    job_id: null,
    script: { id: '', name: '' },
    configs: [],
    files: [],
    created_at: '',
    updated_at: '',
  }
  const selectors = createEntityAdapter().getSelectors()
  const dispatch: AppDispatch = useDispatch()
  const resultEntities = useSelector((state: DefaultState) => state.results)
  const resultArray = selectors.selectAll(resultEntities)
  const resultsError = useSelector((state: DefaultState) => state.results.error)
  const [show, setShow] = useState(false)
  const [selectedResult, setSelectedResult] = useState(initialState)

  const toggleModal = e => {
    if (e.element.id && !show) {
      setSelectedResult(resultEntities.entities[e.element.id])
    } else {
      setSelectedResult(initialState)
    }
    setShow(!show)
  }

  const handleDelete = (_, data) => {
    const r = window.confirm(
      `Are you sure you want to delete the following result: ${data.name}?`
    )
    if (r === true) {
      dispatch(removeResult(data.id))
      dispatch(getAllResults())
    }
  }

  useEffect(() => {
    const initialState = async () => {
      await dispatch(getAllResults())
    }
    initialState()
  }, [dispatch])

  return (
    <>
      {show ? (
        <ResultFilesModal
          selectedResult={selectedResult}
          resultsError={resultsError}
          toggleModal={toggleModal}
          show={show}
        />
      ) : (
        <></>
      )}
      {resultsError?.code === 'error' && !show ? (
        <ICSErrorCard
          code={resultsError.code}
          message={resultsError.message}
          fields={resultsError.fields}
        />
      ) : (
        <ICSDataGrid
          dataSource={Object.values(resultArray)}
          columnOptions={[
            {
              type: 'buttons',
              caption: 'Action',
              width: 110,
              buttons: [
                {
                  icon: 'trash',
                  hint: 'Delete',
                  render: e => {
                    const { data } = e
                    return (
                      <ICSActionIcon
                        key={`action_delete_${data.id}`}
                        icon='trash'
                        title='Delete'
                        renderData={e}
                        onClick={e => {
                          handleDelete(e, data)
                        }}
                      />
                    )
                  },
                },
              ],
            },
            { dataField: 'id', caption: 'Result Id', width: 280 },
            {
              width: 150,
              dataField: 'created_at',
              caption: 'Date Created',
              cellRender: renderDateTime,
            },
            {
              dataField: 'analyzer.name',
              caption: 'Analyzer',
              width: 150,
            },
            { dataField: 'script.name', caption: 'Script' },
            { dataField: 'configs[0].name', caption: 'Configuration' },
            {
              dataField: 'files',
              caption: 'Files',
              width: 180,
              renderAsync: true,
              cellRender: e =>
                renderFiles({
                  e,
                  toggleModal,
                }),
            },
          ]}
        />
      )}
    </>
  )
}

export default ResultsDisplay
